import { BuyerPortalService } from './model/squareup/buyerportal/service';
import rpc from './rpc';

const client = BuyerPortalService.create(rpc());

export default client;
